import React from "react";

const FormattedDate = ({ date, format = {
  year: "numeric",
  month: "long",
  day: "numeric",
  timeZone: "America/New_York"
}}, props) => (
  <time dateTime={date} {...props}>
    {new Intl.DateTimeFormat("en-US", format).format(Date.parse(`${date}T12:00:00-05:00`))}
  </time>
);
export default FormattedDate;